import { Component } from '@angular/core';
import {CardComponent} from "../card/card.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [
    TranslateModule,
    CardComponent
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {

}
